
export function instruction(msg: string): Promise<boolean> {

    return new Promise((resolve) => {

        if (msg === null || msg === undefined || msg.length < 2) return false;

        const form = document.createElement('form');
        form.classList.add('pop');

        form.innerHTML = `
        <p>${msg}</p>
        <div class="buttons">
            <button id="btnOk">OK</button>
            <button id="btnCancel">Avbryt</button>
        </div>
    `;

        const btnOk = form.querySelector('#btnOk') as HTMLButtonElement;
        btnOk?.addEventListener('click', (e: Event) => {
            e.preventDefault();
            form.remove();
            resolve(true);
        });

        const btnCancel = form.querySelector('#btnCancel') as HTMLButtonElement;
        btnCancel?.addEventListener('click', (e: Event) => {
            e.preventDefault();
            form.remove();
            resolve(false);
        });

        document.body.appendChild(form);
    });
}



